<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-header>
                <i class="icon-menu mr-1"></i>Data Table Alert
            </b-card-header>
            <b-card-body>
                <alert></alert>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import alert from './Table'
export default {
    name: 'alerts',
    components: {
        alert,
    },
}
</script>
